import React, { useState } from "react";
import "./PersonCardAiChat.css";

const PersonCardAiChat = ({ person }) => {
  const [imageError, setImageError] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const getInitials = (name) => {
    if (!name) return "";
    const [first, last] = name.split(" ");
    return `${first?.[0] || ""}${last?.[0] || ""}`.toUpperCase();
  };

  return (
    <div className="pcac-container">
      {/* Profile Section */}
      <div className="pcac-header">
        {imageError || !person?.photo_url ? (
          <div className="pcac-initials-fallback">
            {getInitials(person?.name)}
          </div>
        ) : (
          <img
            src={person.photo_url}
            alt={person.name}
            className="pcac-profile-pic"
            onError={() => setImageError(true)}
          />
        )}
      </div>

      {/* Info Section */}
      <div className="pcac-info">
        <h3 className="pcac-name">{person.name}</h3>
        <p className="pcac-title">{person.title}</p>
        <p className="pcac-org">{person.organization?.name}</p>

        {person.city || person.country ? (
          <p className="pcac-location">
            {person.city}, {person.country}
          </p>
        ) : null}

        {person.linkedin_url && (
          <p className="pcac-link">
            LinkedIn:{" "}
            <a href={person.linkedin_url} target="_blank" rel="noreferrer">
              View Profile
            </a>
          </p>
        )}

        {/* Toggle Button */}
        <div className="pcac-button-row">
          <button
            className="pcac-circle-toggle-btn"
            onClick={() => setShowDetails((prev) => !prev)}
            title={showDetails ? "Hide Details" : "View Details"}
          >
            <span className={`pcac-arrow-icon ${showDetails ? "up" : "down"}`} />
          </button>
        </div>

        {/* Details Section */}
        {showDetails && (
          <div className="pcac-more">
            <p>
              Email Status: <strong>{person.email_status}</strong>
            </p>

            {person.employment_history?.length > 0 && (
              <ul className="pcac-job-history">
                {person.employment_history.slice(0, 3).map((job) => (
                  <li key={job.id}>
                    {job.title} @ {job.organization_name}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PersonCardAiChat;
